export default __webpack_public_path__ + "static/media/cartao_empresarial_poupa.1253db29.jpg";